<!--
 * @Description: 网盘管理-学校网盘 添加
 * @Author: PF
 * @Date: 2024-06-04 14:28:52
 * @LastEditors: PF
 * @LastEditTime: 2024-06-12 16:18:03
-->
<template>
  <div>
    <el-dialog class="w500 h220" :model-value="openAdd" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon"><Edit /></el-icon>
          <span class="header-title">新建文件夹</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openAdd', emits, false)">
            <el-icon><Close /></el-icon>
          </el-button>
        </div>
      </template>
      <el-form ref="ruleFormRef" :model="ruleForm" label-width="92px">
        <el-row>
          <el-col :span="24">
            <el-form-item label="文件夹名称" prop="wjmc" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-input v-model="ruleForm.wjmc" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer_but">
            <el-button type="primary" @click="submit()">保存</el-button>
            <el-button type="info" @click="closeWindow('openAdd', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { defineEmits, ref, defineProps, watch, unref } from 'vue'
import { submitForm, closeWindow } from '@/api/common.js'

const props = defineProps({ openAdd: { type: Boolean, required: true }, row: { type: Object, required: false } })
const emits = defineEmits(['update:openAdd', 'ReturnData'])

const ruleFormRef = ref(null)
const ruleForm = ref({})

watch(
  () => props.openAdd,
  () => {
    if (props.openAdd) {
      ruleForm.value.wjlx = 1 // 1-文件夹，2-文件
      ruleForm.value.wplx = props.row.wplx // 网盘类型:0-学校，1-个人网盘，2-部门网盘
      ruleForm.value.wjscrid = props.row.wplx === 2 ? props.row.wjscrid : undefined
      ruleForm.value.fwjid = props.row.fwjid || undefined
    }
  },
  { deep: true, immediate: true }
)

// 提交
const submit = async () => {
  submitForm({
    url: '/api/v2/bangong/wangpanguanli/wangpanwenjianguanli/savefilefolder',
    ruleFormRef: unref(ruleFormRef),
    ruleForm: ruleForm.value,
    callback: function () {
      closeWindow('openAdd', emits, true)
    }
  })
}
</script>
